import crud from "./_crud";

const actions = crud('bank_transaction', 'el movimiento bancario', 'los movimientos bancarios');

export default actions